<ng-container *ngIf="isBrowser">
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{'Zwischenstopps'}}</span>
        <div class="tmp-section-body tmp-flexy">
            @if(!partner()?.filters?.hideMNurDirektflug) {
            <button multilang class="tmp-f-btn" [class.tmp-f-btn-selected]="direktflug === 'N'"
                (click)="selectStops('N')" matRipple>{{'nur Direktflug'}}</button>
            }
            @if(!partner()?.filters?.hideMax1stopp) {
            <button multilang class="tmp-f-btn ml5" [class.tmp-f-btn-selected]="direktflug === '1'"
                (click)="selectStops('1')" matRipple>{{'max 1 Stopp'}}</button>
            }
            @if(!partner()?.filters?.hideMax2stopp) {
            <button multilang class="tmp-f-btn ml5" [class.tmp-f-btn-selected]="direktflug === '2'"
                (click)="selectStops('2')" matRipple>{{'max 2 Stopps'}}</button>
            }
        </div>
    </div>
</ng-container>